// @ts-ignore
import $ from 'jquery';
import ConstLayout from "../../core/gd/const/layout";

// const debug = '{LAYOUT.TOP}'
const debug = false

export default class LayoutTop {

    public $top : any
    public $contentCenter : any
    public isOpen : boolean
    public height : number

    constructor() {

        this.$top = null;
        this.$contentCenter = null;

        this.isOpen = false;

        this.height = ConstLayout.TOP_WITHOUT_SUBMENU;   // default height for top panel...
    }

    open(height:number | null =null) {

        debug && console.log(debug,"open height=",height);

        // if open and same view mode - do nothing
        if (this.isOpen && (!height || this.height===height)) {
            debug && console.log(debug, "TOP ALREADY OPEN & same view mode - DO NOTHING");
            return false;
        }

        // if (!height) {
        //     debug && console.log(debug, "Height not specified - we dont' need it?");
        //     return false
        // }

        if (!this.$top) this.$top = $("#ui-top-panel");
        if (!this.$contentCenter) this.$contentCenter = $("#ui-content-center");

        if (height) this.height = height;

        this.isOpen = true;

        // remove ALL old classes
        this.$top.height(this.height+"px");
        this.$top.removeClass();

        this.$contentCenter.removeClass("no-top-panel");
        this.$contentCenter.css({'top' : this.height + 'px'});
        this.$contentCenter.height("calc(100% - "+this.height+"px)");

    }

    close() {

        debug && console.log(debug,"close");

        // if open and same view mode - do nothing
        if (!this.isOpen) {
            debug && console.log(debug, "TOP ALREADY Closed - DO NOTHING");
            return false;
        }

        if (!this.$top) this.$top = $("#ui-top-panel");
        if (!this.$contentCenter) this.$contentCenter = $("#ui-content-center");

        this.isOpen = false;

        this.$top.addClass('hidden');
        this.$contentCenter.addClass("no-top-panel");
        this.$contentCenter.css({'top' : 0});
        this.$contentCenter.height("100%");

    }

    fullScreen(enabled:boolean) {

        if (!this.$top) this.$top = $("#ui-top-panel");
        if (!this.$contentCenter) this.$contentCenter = $("#ui-content-center");

        if (enabled) {

            const fullScreenHeight = 0; // tis is hot patch - completely hide top panel !45; // 45 = controls height
            const topOffset = -(this.height - fullScreenHeight);

            this.$top.addClass('full-screen');
            this.$top.css({'top' : topOffset + 'px'});

            this.$contentCenter.css({'top' : fullScreenHeight + 'px'});
            this.$contentCenter.height("calc(100% - " + fullScreenHeight + "px)");

        } else {
            this.$top.removeClass('full-screen');
            this.$top.css({'top' : 0});

            this.$contentCenter.css({'top' : (this.height) + 'px'});
            this.$contentCenter.height("calc(100% - " + (this.height) + "px)");
        }




    }

    disable() {
        if (!this.$top) this.$top = $("#ui-top-panel");
        this.$top.addClass('disabled');
    }

    enable() {
        if (!this.$top) this.$top = $("#ui-top-panel");
        this.$top.removeClass('disabled');
    }


}
